import { getMmInPx } from './utils/screen';

export const BASE_UNIT = 'mm';
export const DATA = 'data';
export const CLASSNAME_MODIFIERS = [
  'primary',
  'secondary',
  'success',
  'warning',
  'danger',
  'disabled',
  'negative',
  'small',
];
export const RESET_REDUX_STORE = '__RESET_REDUX_STORE__';
export const INCH_IN_MM = 25.4;
export const MM_IN_PT = 0.352777778;
export const MM_IN_PX = getMmInPx();
